import { lazy } from 'react';


export const Students = lazy(() => import('./Students'));
